
export default class TemplateTypeConst {
    static PRIME_PRESTIGE = 'prestige'
    static PRIME_PRESTIGE_INTRASOFT = 'prestige-intrasoft'
    static PRIME_PRESTIGEIS = 'prestigeis'
    static PRIME_ULTIMA = 'ultima'
    static PRIME_APOLLO = 'apollo'
  }
  